var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Section",
    _vm._b(
      {
        attrs: {
          breadCrumbs: _vm.breadCrumbs,
          shouldShowSearch: _vm.shouldShowSearch,
          title: _vm.title,
          toolbarActions: _vm.toolbarActions,
          icon: "event",
          isLoading: _vm.isLoading,
        },
        on: {
          onClickBreadcrumb: (val) => _vm.$emit("onClickBreadcrumb", val),
          onClicked: (val) => _vm.$emit(val),
        },
        scopedSlots: _vm._u([
          {
            key: "toolbarExtension",
            fn: function () {
              return [
                _c(
                  "v-layout",
                  {
                    attrs: {
                      row: "",
                      wrap: "",
                      "justify-space-between": "",
                      subheading: "",
                    },
                  },
                  [
                    _c("v-flex", { attrs: { shrink: "" } }, [
                      _vm.activityDetail.locationId
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "span",
                                              _vm._g({}, on),
                                              [
                                                _c("v-icon", [_vm._v("place")]),
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm._entityPropertyValueByName(
                                                        {
                                                          entityList:
                                                            _vm.locationList,
                                                          idKey: "id",
                                                          idValue:
                                                            _vm.activityDetail
                                                              .locationId,
                                                          propertyKey: "name",
                                                        }
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2896705793
                                  ),
                                },
                                [_vm._v(" "), _c("span", [_vm._v("Location")])]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "span",
                                        _vm._g({}, on),
                                        [
                                          _c("v-icon", [_vm._v("schedule")]),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm._formatJavascriptDate({
                                                  date: _vm.activityDetail
                                                    .dateTimePerformedOn,
                                                })
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [_vm._v(" "), _c("span", [_vm._v("Performed On")])]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        attrs: {
                          shrink: "",
                          "text-xs-left": "",
                          "text-sm-right": "",
                        },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "span",
                                          _vm._g({}, on),
                                          [
                                            _c("v-icon", [_vm._v("face")]),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm._entityPropertyValueByName(
                                                    {
                                                      entityList: _vm.userList,
                                                      idKey: "id",
                                                      idValue:
                                                        _vm.activityDetail
                                                          .userIdPerformedBy,
                                                      propertyKey: "name",
                                                    }
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _vm._v(" "),
                                _c("span", [_vm._v("Performed By")]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.activityDetail.comments
                      ? _c(
                          "v-flex",
                          { attrs: { xs12: "" } },
                          [
                            _c("v-icon", [_vm._v("comment")]),
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.activityDetail.comments) +
                                "\n      "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "Section",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }